import { toast } from "react-toastify";


class AudioService {
    constructor() {
        this.audioContext = null;
        this.audioBuffer = null;
        this.isAllowed = false;
    }

    // Call this on first user interaction
    async init() {
        if (this.audioContext) return;

        try {
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
            // Load audio file
            const response = await fetch('/notification.mp3');
            this.audioBuffer = await this.audioContext.decodeAudioData(await response.arrayBuffer());
            this.isAllowed = true;
        } catch (error) {
            console.error('Audio initialization failed:', error);
        }
    }

    async play() {
        if (!this.isAllowed) {
            toast.warn('Audio not initialized or blocked.Enable from Security Section to get notifications.');
            return;
        }

        try {
            // Some browsers require resuming the context after user interaction
            if (this.audioContext.state === 'suspended') {
                await this.audioContext.resume();
            }

            const source = this.audioContext.createBufferSource();
            source.buffer = this.audioBuffer;
            source.connect(this.audioContext.destination);
            source.start(0);

            // Clean up after playback
            source.onended = () => {
                source.disconnect();
            };
        } catch (error) {
            console.error('Playback failed:', error);
        }
    }
}

export const audioService = new AudioService();